import {$getSelection, $isRangeSelection, $isTextNode, LexicalEditor} from 'lexical';
import {languageTabs} from '../../Automations/components/RuleDialog/parts/AutomationActionToolbar/constants';
import {defaultContext} from '../reducer/model';
import {getActiveMessageLang} from '../../Automations/components/RuleDialog/parts/AutomationActionTemplate/BusinessRuleActionTemplate/utils';
import {TreeNodeProps} from '@priority-software/priority-style-react';
import {
    replaceIdsWithTitles,
    replaceIdsWithTitlesForHtml,
    replaceTitlesWithIds
} from './treeActions';
import {isBase64} from '../../../utils/base64';
import {TAlertMessage, TAlertMessageDictionary} from '../../Automations/types';
import {TEditorTemplatesDictionary, TEmailTemplateState} from '../reducer/types';
import {TVoidFunction} from '../types';

export const updateEditorSelection = (
    editor: LexicalEditor,
    content: string,
    cb?: TVoidFunction
) => {
    editor.focus();

    editor.update(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
            selection.insertText(content);
            // The selection will automatically be positioned after the inserted content
            // We need to select the inserted content for the callback
            const newSelection = $getSelection();
            if ($isRangeSelection(newSelection)) {
                const insertedStart = newSelection.anchor.offset - content.length;
                const insertedEnd = newSelection.anchor.offset;
                const anchorNode = newSelection.anchor.getNode();
                if ($isTextNode(anchorNode)) {
                    anchorNode.select(insertedStart, insertedEnd);
                }
            }

            cb?.();
        }

        return false;
    });
};

export const wrapValueWithDiv = (value: string) => value || '';

export const renderDefault = (data: TAlertMessageDictionary, treeValues?: TreeNodeProps) => {
    const language = getActiveMessageLang();

    const templates = languageTabs.reduce((acc, tab) => {
        const langID = tab.id;
        const initialValues = data[langID] satisfies TAlertMessage;
        const editorSubject = replaceIdsWithTitles(initialValues?.Subject || '', treeValues) || '';
        const editorSubjectIds =
            replaceTitlesWithIds(initialValues?.Subject || '', treeValues) || '';
        const emailHtml = wrapValueWithDiv(
            replaceIdsWithTitlesForHtml(initialValues?.Message, treeValues)
        );

        acc[langID] = {
            editorSubject,
            editorSubjectIds,
            emailHtml
        } satisfies TEmailTemplateState;
        return acc;
    }, {} as TEditorTemplatesDictionary);

    return {
        states: {
            ...defaultContext.states,
            templates,
            treeValues,
            language,
            aiLoading: false
        }
    };
};

export const getUt8Array = (base64: string) => {
    const condition = isBase64(base64);

    if (condition) {
        const binaryString = atob(base64);
        return new Uint8Array(binaryString.split('').map(char => char.charCodeAt(0)));
    }

    return null;
};
